module.exports = __webpack_public_path__ + "static/media/chilicorn.a8d6bd0c.png";